import * as yup from 'yup';

const SchemaBusinessCertifications = yup.object().shape({
  autorizacionTransporte: yup.boolean().required('El campo es obligatorio'),
  autorizacionAcopio: yup.boolean().required('El campo es obligatorio'),
  registroNacionalRDB: yup.boolean().required('El campo es obligatorio')
});

export { SchemaBusinessCertifications };
